import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-manpower',
  templateUrl: './add-manpower.component.html',
  styleUrls: ['./add-manpower.component.scss']
})
export class AddManpowerComponent implements OnInit {
  p: number = 1;
  itemsPerPage: number = 10;
  userRecord!: any[];
  seachText: any;
  userRecordData: any[] | undefined;
  states!: any[];
  selectedState!: any;

  StateRecord: any[] | undefined;
  [x: string]: any;

  adduserForm!: FormGroup;
  submitted = false;
  success = false;
  isReadMode = true;
  role: any;
  roles_data!: any;
  constructor(private formBuilder: FormBuilder, private router: Router, private fswService: FswService, private authService: AuthService, private spinnerService: NgxSpinnerService, private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.role = this.authService.getRole();
    this.adduserForm = this.formBuilder.group({
      userType: [''],
      userName: [''],
      userMobile: [''],
      useremail: [''],
      userId: [''],
      vehicleNo: ['']
    })

    //list
    this.bindState();
    // this.getUserData();
    // this.userRecordData = [
    //   {
    //     "userType": "Technical"
    //     , "userName": "Test AC"
    //     , "userMobile": "9876543212"
    //     , "useremail": "kushal47@gmail.com"
    //     , "userId": "testac"
    //   }
    // ];
    this.route.params.subscribe(params => {

      this.userId = params['userId']; // (+) converts string 'id' to a number
      this.selectedvehicle = this.userId;
    });
    this.bindmanpowerlist(this.userId);
  }

  bindmanpowerlist(userId) {
    debugger;
    this.spinnerService.show();
    this.fswService.getFSWManpowerlist(userId).subscribe((data: any[]) => {
      this.manpowerData = data;
      this.spinnerService.hide();
    })
  }

  getUserData() {
    this.spinnerService.show();
    this.fswService.getUsersDetail().subscribe((data: any[]) => {
      console.log(data);
      this.userRecord = data;
      this.userRecordData = data;
      this.spinnerService.hide();
    })
  }
  bindState(): void {
    this.fswService.getState().subscribe((data: any[]) => {
      console.log(data);
      this.states = data;
      this.StateRecord = data;
    })

  }
  search() {
    debugger
    console.log(this.seachText);
    this.userRecordData = this.userRecord;
    if (this.seachText != undefined) {
      let obj = this.userRecord.filter(m => (m.userId == this.seachText) || (m.userName == this.seachText));
      this.userRecordData = obj;
    }
    if (this.selectedState != undefined) {
      let obj = this.userRecord.filter(m => (m.stateCode == this.selectedState));
      this.userRecordData = obj;
    }
    return this.userRecordData;
  }

  updateRow(x: any) {
    debugger
    var delBtn = confirm(" Do you want to update ?");
    if (delBtn == true) {
      debugger
      if (x) {
        this.spinnerService.show();
        this.isReadMode = false;
        this.bindState();
        this.id = x.id;
        if (x.roleName == "SO") {
          x.roleName = "ROLE_SO";
        }
        else if (x.roleName == "RO") {
          x.roleName = "ROLE_RO";
        }
        this.adduserForm.controls['userType'].setValue(x.userType);
        this.adduserForm.controls['userName'].setValue(x.userName);
        this.adduserForm.controls['userId'].setValue(x.userId);
        this.adduserForm.controls['userMobile'].setValue(x.userMobile);
        this.adduserForm.controls['useremail'].setValue(x.useremail);
        this.spinnerService.hide();
      }
      else {
        this.isReadMode = false;
      }
    }
  }
  createRow() {
    var delBtn = confirm(" Do you want to create new user?");
    if (delBtn == true) {
      this.isReadMode = false;
    }
  }
  onupdateUserSubmit() {
    this.spinnerService.show();
    this.submitted = true;
    debugger
    if (this.adduserForm.invalid) {
      return;
    }
    var role = ["ROLE_SO"]
    this.adduserForm.controls['roles'].setValue(role);
    console.log(this.adduserForm.value);
    this.fswService.updateProfileData(this.id, this.adduserForm.value)
      .subscribe(
        response => {
          this.submitted = true;
          this.spinnerService.hide();
          this.isReadMode = true;
          this.bindState();
          this.getUserData();
          this.seachText = null;
        },
        error => {
          console.log(error);
          this.spinnerService.hide();

        });

    this.success = true;
    this.adduserForm.reset({});
  }
  closeAlert() {
    this.success = false;
  }
  reset() {
    debugger
    // window.location.reload();
    this.selectedState = "";
    this.seachText = "";
    this.fromDate = "";
    this.endDate = "";
    this.ngOnInit();
  }

  back(): void {
    this.location.back()
  }


}
